import { Link } from '@tanstack/react-router'
import { ArrowLeftIcon, ShieldCheckIcon } from '@heroicons/react/24/outline'
import { PageHeader } from '@components/PageHeader'
import PdfDocument from '@components/PdfDocument'
import Footer from '@/components/Footer'
import privacyPolicyPdf from '@/assets/PrivacyPolicy.pdf'

const PrivacyPolicy = () => {
  return (
    <div className='min-h-screen flex flex-col bg-gray-100'>
      <div className='container mx-auto w-full max-w-4xl px-4 sm:px-6 lg:px-8 flex flex-col pb-10 flex-1'>
        <div className='mt-4 mb-3'>
          <PageHeader
            icon={<ShieldCheckIcon className='h-5 w-5' />}
            title='Privacy Policy'
            right={
              <Link
                to='/'
                className='link link-primary inline-flex items-center gap-1 text-sm'
              >
                <ArrowLeftIcon className='h-4 w-4' />
                Back
              </Link>
            }
          />
        </div>

        <div className='py-4'>
          <PdfDocument
            file={privacyPolicyPdf}
            downloadUrl={privacyPolicyPdf}
          />
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default PrivacyPolicy
